import ApiCaller from '../lib/ApiCaller';
import SystemSetting from '../lib/common/models/systemSetting';

class SystemSettingsApi {
  apiCaller: ApiCaller;

  constructor(apiCaller: ApiCaller) {
    this.apiCaller = apiCaller;
  }

  getAll(): Promise<SystemSetting[]> {
    return this.apiCaller
      .call('/v1/settings/', 'GET')
      .then((data) => {
        if (data.error) {
          throw Error(data.error);
        }
        return data.map((setting: any) => new SystemSetting(setting));
      });
  }

  getNcapStatus(): Promise<{ enabled: boolean }> {
    return this.apiCaller
      .call('/v1/settings/ncap', 'GET')
      .then((data) => {
        if (data.error) {
          throw Error(data.error);
        }
        return data;
      });
  }

  updateSetting(
    key: string,
    value: any,
    description?: string,
  ): Promise<SystemSetting> {
    return this.apiCaller
      .call(`/v1/settings/${key}`, 'PUT', { value, description })
      .then((data) => {
        if (data.error) {
          throw Error(data.error);
        }
        return new SystemSetting(data);
      });
  }
}

export default SystemSettingsApi;

